import r from "../../shared-lib/braze-shared-lib.js";
export default class FeatureFlag {
  constructor(t, r = !1, e = {}) {
    (this.id = t),
      (this.enabled = r),
      (this.properties = e),
      (this.id = t),
      (this.enabled = r),
      (this.properties = e);
  }
  getStringProperty(t) {
    const r = this.properties[t];
    return null == r
      ? (this.yr(t), null)
      : this.Er(r)
      ? r.value
      : (this.Br("string"), null);
  }
  getNumberProperty(t) {
    const r = this.properties[t];
    return null == r
      ? (this.yr(t), null)
      : this.Ir(r)
      ? r.value
      : (this.Br("number"), null);
  }
  getBooleanProperty(t) {
    const r = this.properties[t];
    return null == r
      ? (this.yr(t), null)
      : this.Nr(r)
      ? r.value
      : (this.Br("boolean"), null);
  }
  ss() {
    const t = {};
    return (
      (t[FeatureFlag.hs.ns] = this.id),
      (t[FeatureFlag.hs.Fe] = this.enabled),
      (t[FeatureFlag.hs.we] = this.properties),
      t
    );
  }
  Br(t) {
    r.D.info(`Property is not of type ${t}.`);
  }
  yr(t) {
    r.D.info(`${t} not found in feature flag properties.`);
  }
  Er(t) {
    return "string" === t.type && "string" == typeof t.value;
  }
  Ir(t) {
    return "number" === t.type && "number" == typeof t.value;
  }
  Nr(t) {
    return "boolean" === t.type && "boolean" == typeof t.value;
  }
}
(FeatureFlag.hs = { ns: "id", Fe: "e", we: "pr" }),
  (FeatureFlag.At = { ns: "id", Fe: "enabled", we: "properties" });
